module.exports = __webpack_public_path__ + "static/scale-model-of-santa-rosa-california-cc18d688ed4a664882dfe8fa8a6f59e1.png";